import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
        token: '',
        signedIn: false,
        permissions: [],
        navigation: []
    },
	reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload.data1.id
            state.navigation = action.payload.data
            state.permissions = action.payload.data2
            debugger
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.permissions = []
            state.navigation = []
        },
        setToken: (state, action) =>  {
            state.token = action.payload
        }
	},
})

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer